import logo from "@/assets/rae-cloud-logo.png";

// Rae Cloud LLC brand logo mark on a white tile.
export const LogoMark = ({ size = 40 }) => {
  return (
    <span
      className="inline-flex items-center justify-center bg-white shrink-0 shadow-sm ring-1 ring-gray-200"
      style={{ width: size, height: size }}
    >
      <img
        src={logo}
        alt="Rae Cloud LLC logo"
        className="object-contain"
        style={{ width: size * 0.82, height: size * 0.82 }}
      />
    </span>
  );
};
